export const RATE_CONDITION_COLUMN_PREFIX = 'rate';
export const ACTION = {
    UPSERT: 'upsert',
    REMOVE: 'remove',
};
export const STATUS = {
    CONFIRMED: 'confirmed',
    EXPIRED: 'expired',
};
